import {
  useGetAdminConnectivityMisc,
  usePostAdminConnectivityMisc
} from '@ijoin/hooks';
import { createFileRoute } from '@tanstack/react-router';

import { ConnectivityChecks } from '../../components';

const MiscConnectivityPage = () => (
  <ConnectivityChecks
    label='misc'
    linkIntegration={false}
    queryKey='/api/v3/admin/connectivity/misc'
    showHost
    showOrganizations={false}
    testId='miscConnectivity'
    useQuery={useGetAdminConnectivityMisc}
    useRefresh={usePostAdminConnectivityMisc}
  />
);

export const Route = createFileRoute('/connectivity/misc')({
  component: MiscConnectivityPage
});
